import { cn } from "@/lib/utils";
import UserCardLoading from "../components/UserCardLoading";

const Skeleton = ({ className }: { className?: string }) => (
  <div className={cn("skeleton rounded-md h-2 bg-white/08", className)} />
);

const AvatarLoading = () => (
  <div className="flex-center">
    <div className="relative">
      <div className="rounded-full overflow-hidden">
        <Skeleton className="size-16" />
      </div>
    </div>
  </div>
);

const TextLoading = ({
  lines = 1,
  width,
}: {
  lines?: number;
  width?: string;
}) => (
  <div className="flex flex-col gap-2 w-full">
    {Array.from({ length: lines }).map((_, idx) => (
      <Skeleton
        key={idx}
        className={`h-2 rounded-md ${
          width ?? (idx === 0 ? "w-3/4" : "w-full")
        }`}
      />
    ))}
  </div>
);

const SuperWinnerLoading = () => (
  <div className="flex flex-col items-center gap-3 w-full py-[30px]">
    <div className="flex flex-col items-center gap-2">
      <AvatarLoading />
      <div className="flex flex-col items-center gap-1">
        <Skeleton className="h-4 w-32 rounded-md" />
        <Skeleton className="h-3 w-24 rounded-md" />
      </div>
    </div>
    <div className="flex flex-col items-center gap-1.5 w-full max-w-xs">
      <Skeleton className="h-6 w-3/4 rounded-md" />
      <TextLoading lines={3} width="w-full" />
    </div>
  </div>
);

const MembersListLoading = ({ count = 5 }: { count?: number }) => (
  <div className="flex flex-col gap-0.5">
    {Array.from({ length: count }).map((_, idx) => (
      <UserCardLoading key={idx} />
    ))}
  </div>
);

export const WinnersLoading = () => (
  <div className="container">
    <SuperWinnerLoading />
    <MembersListLoading count={3} />
  </div>
);
